
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"9","height":"12","viewBox":"0 0 536 731.7","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M409.317 558.867V499.87h-52.593c0-30.184 14.635-59.454 30.184-68.601 9.147-7.774 29.727-11.433 47.563-2.286 23.323 13.262 24.696 51.679 12.805 69.058 111.132-20.581 100.156-128.055 62.198-166.929-30.642-31.556-64.027-36.129-89.638-26.525-58.539 21.037-97.87 91.01-99.7 195.283h-30.641c0-94.669 16.464-124.853 59.454-244.218 21.951-56.253 8.689-125.768-29.727-189.796C305.044 42.99 287.666 22.409 268 0c-19.665 22.409-37.044 42.99-51.222 65.856-38.416 64.028-51.679 133.543-29.726 189.796 42.989 119.365 59.453 149.549 59.453 244.218h-30.642c-1.829-104.273-41.16-174.246-99.699-195.283-25.611-9.604-58.996-5.031-89.638 26.525-37.959 38.874-48.935 146.348 62.198 166.929-11.891-17.379-10.519-55.796 12.806-69.058 17.835-9.147 38.415-5.488 47.562 2.286 15.55 9.147 30.184 38.417 30.184 68.601h-52.593v58.997h109.304c-1.373 30.641-17.837 54.423-48.478 67.685 3.659 12.806 22.409 38.874 48.02 37.045 5.03 27.44 9.604 42.989 32.471 68.143 22.866-25.154 27.44-40.703 32.471-68.143 25.611 1.829 44.361-24.239 48.02-37.045-30.641-13.262-47.105-37.044-48.478-67.685h109.304z","fill":"#fff"}})])
          )
        }
      }
    